import React, { useState } from 'react';
import axios from 'axios';
import { API } from '../config';
import { SESSION_TUGADI } from '../authInterceptor';
import { useNavigate } from 'react-router-dom';
import { tr, tilTanlanganmi, tilniOzgartir, serverTiliniQabulQil } from '../til';
import TilTanlash from '../components/TilTanlash';

function Login() {
  const [badge_number, setBadge] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Sessiya tugagani uchun bu yerga qaytarilgan bo'lsa — sababini aytamiz.
  // Belgi bir marta ko'rsatilib, darhol tozalanadi.
  const [sessionTugadi] = useState(() => {
    const bor = sessionStorage.getItem(SESSION_TUGADI) === '1';
    sessionStorage.removeItem(SESSION_TUGADI);
    return bor;
  });

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${API}/auth/login`, {
        badge_number,
        password
      });
      localStorage.setItem('token', res.data.token);

      // Til: bu qurilmada o'zi tanlagan bo'lsa — serverga yozamiz (push
      // shu tilda kelsin). Tanlamagan bo'lsa — boshqa qurilmada saqlangan
      // tilni olamiz.
      const serverTili = res.data.user?.til;
      if (tilTanlanganmi()) {
        tilniOzgartir(localStorage.getItem('til'), { qaytaYukla: false });
      } else if (serverTiliniQabulQil(serverTili)) {
        window.location.replace('/');
        return;
      }
      navigate('/');
    } catch (err) {
      setError(tr("Login yoki parol noto'g'ri"));
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5' }}>
      <div style={{ background: '#fff', padding: '40px', borderRadius: '12px', boxShadow: '0 2px 20px rgba(0,0,0,0.1)', width: '360px' }}>
        <h2 style={{ marginBottom: '8px', fontSize: '22px' }}>{tr("Manguberdi")}</h2>
        <p style={{ color: '#888', marginBottom: '16px', fontSize: '14px' }}>{tr("Admin panel")}</p>

        <div style={{ marginBottom: '20px' }}>
          <TilTanlash />
        </div>

        {sessionTugadi && !error && (
          <p style={{
            background: '#fff6e5', color: '#8a6d2d', padding: '10px 12px',
            borderRadius: '8px', fontSize: '13px', marginBottom: '16px'
          }}>
            {tr("Sessiya muddati tugadi. Iltimos, qaytadan kiring.")}
          </p>
        )}

        {error && <p style={{ color: 'red', fontSize: '13px', marginBottom: '16px' }}>{error}</p>}

        <div style={{ marginBottom: '16px' }}>
          <label style={{ fontSize: '13px', color: '#555', display: 'block', marginBottom: '6px' }}>{tr("Login")}</label>
          <input
            type="text"
            value={badge_number}
            onChange={e => setBadge(e.target.value)}
            placeholder="12345"
            style={{ width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }}
          />
        </div>

        <div style={{ marginBottom: '24px' }}>
          <label style={{ fontSize: '13px', color: '#555', display: 'block', marginBottom: '6px' }}>{tr("Parol")}</label>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="••••••"
            style={{ width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px' }}
          />
        </div>

        <button
          onClick={handleLogin}
          style={{ width: '100%', padding: '12px', background: '#1a1a2e', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '500' }}
        >
          {tr("Kirish")}
        </button>
      </div>
    </div>
  );
}

export default Login;